// src/pages/Unauthorized.js

import React from 'react';

const Unauthorized = () => {
  return (
    <div>
      <h1>Unauthorized</h1>
      <p>You do not have access to this page.</p>
      {/* Add more content here */}
    </div>
  );
};

export default Unauthorized;
